<template>
    <div class="row">
      <div class="col-12 logo">
        <router-link to="/">
          <img class="metastory-logo light launch" src="@/assets/logo/logo-mark.svg" title="metastory">
          <img class="metastory-logo dark launch" src="@/assets/logo/logo-mark-white.svg" title="metastory">
        </router-link>

        <router-link v-if="!!$route.meta.data.routeTo" :to="routeFlag[$route.meta.data.routeTo].route">{{ routeFlag[$route.meta.data.routeTo].content }}</router-link>
        <StepperElement v-if="!!$route.meta.data.step" :step="$route.meta.data.step"></StepperElement>
      </div>
    </div>
    <div v-if="!!$route.meta.data.title" class="row">
      <div class="col-12 headline">
        <h1>{{ $route.meta.data.title }}</h1>
        <p>{{ $route.meta.data.subtitle }}</p>
      </div>
    </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { AuthenticationNs } from '@shared/types';
import { StepperElement } from '@shared/components';

export default defineComponent({
  name: 'AuthenticationCardHeaderWidget',
  components: {
    StepperElement,
  },
  data() {
    return {
      routeFlag: {
        signIn: {
          route: '/auth/sign-in',
          content: 'Sign In',
          isVisible: true,
        },
        signUp: {
          route: '/auth/sign-up',
          content: 'Sign Up',
          isVisible: true,
        },
        logout: {
          route: '',
          content: '',
          isVisible: false,
        },
      } as AuthenticationNs.RouteFlagInterface,
    };
  },
});

</script>
